var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"copy-button",class:{ 'copied': _vm.copied },attrs:{"title":_vm.copied ? 'Copied!' : 'Click to copy'},on:{"click":_vm.handleCopy}},[(!_vm.copied)?_c('i',{staticClass:"bi bi-clipboard"}):_c('i',{staticClass:"bi bi-check2"})])
}
var staticRenderFns = []

export { render, staticRenderFns }